<script setup>
import { onUnmounted, watch, onMounted, computed, ref } from "vue";
import Sidebar from "./Sidebar.vue";
import Topbar from "./Topbar.vue";
import { isLg, isXl } from "@utils/mediaQuery";
import { Alert, MediaUploaderModal, Icon, Tabs, Tab } from "@components";
import { mediaUploader } from "@utils/mediaUploader";
import draggable from "vuedraggable";

import Menu from "./Menu.vue";
import MenuSettings from "./MenuSettings.vue";
import MenuDesign from "./MenuDesign.vue";

import { useCustomizer } from "@store/customizer";
const $customizer = useCustomizer();

import { useChatCustomizer } from "@store/chatCustomizer";
const $chatCustomizer = useChatCustomizer();

import { useSettings } from "@store/settings";
const $settings = useSettings();

import { useRoute } from "vue-router";
const route = useRoute();

watch(route, (to, from) => {
  if (to.name !== from.name) {
    mediaUploader.selectImage("undefined");
  }
});

const sidebarMenu = ref(
  $customizer.sidebarFormMenu
    .filter((menu) => menu.visible && !["booking_overview"].includes(menu.id))
    .sort((a, b) => a.priority - b.priority) || []
);

const sidebarStepMenu = ref($chatCustomizer.sidebarStepMenu);

const sidebarStepDragMenu = ref(
  $chatCustomizer.sidebarStepDragMenu.sort((a, b) => a.priority - b.priority)
);

const changeEndSidebarStepDragMenu = () => {
  setTimeout(() => {
    let i = 1;
    sidebarStepDragMenu.value.forEach((menu, index) => {
      $settings.settings.chat_widget[menu.id]["priority"] = i++;
    });
    console.log(sidebarStepDragMenu);
    // $settings.saveSettings("chat_widget", $settings.settings.chat_widget);
  }, 10);
};
const checkMoveSidebarStepDragMenu = (event) => {
  // time cannot be equal or less then date, staff, service
  const maxIndex = Math.max(
    ...[
      sidebarStepDragMenu.value.findIndex((menu) => menu.id == "date"),
      sidebarStepDragMenu.value.findIndex((menu) => menu.id == "staff"),
      sidebarStepDragMenu.value.findIndex((menu) => menu.id == "service"),
    ]
  );
  if (
    event.draggedContext.element.id == "time" &&
    event.draggedContext.futureIndex <= maxIndex
  )
    return false;

  // date, staff, service cannot be equal or more then time
  if (
    ["date", "staff", "service"].includes(event.draggedContext.element.id) &&
    event.draggedContext.futureIndex >=
      sidebarStepDragMenu.value.findIndex((menu) => menu.id == "time")
  )
    return false;

  return true;
};
</script>
<template>
  <div class="min-h-screen">
    <Alert class="fixed z-50 top-3 right-5" />
    <MediaUploaderModal />
    <div class="sticky top-0 z-[1]">
      <Topbar />
      <Sidebar>
        <div
          @click="$customizer.cancel(true)"
          class="cursor-pointer w-full hover:bg-[#F2F4F7] px-3 py-2 flex items-center gap-3 text-[#344054] text-base font-semibold rounded-md mb-6"
        >
          <Icon name="reverseLeft" size="24px" class="text-[#667085]" />
          Back to Dashboard
        </div>

        <Tabs default="steps" key="mainTabs" design="underline">
          <!-- <Tab id="sidebar">Sidebar</Tab> -->
          <Tab id="steps">Steps</Tab>
          <Tab id="settings">Settings</Tab>
          <Tab id="design">Design</Tab>

          <!-- <template #sidebar>
            <MenuSidebar />
          </template> -->

          <template #steps>
            <!-- {{ sidebarMenu.map(menu => {
                        return {
                            title: menu.title,
                            priority: menu.priority
                        }
                    }) }} -->
            <!-- <transition name="fade" mode="out-in"> -->
            <Menu
              class="menu-item"
              :key="sidebarStepMenu[0].title"
              :menu="sidebarStepMenu[0]"
              :serial="1"
              :totalMenu="1"
              :menuIndex="1"
              :data-title="sidebarStepMenu[0].title"
            />
            <Menu
              class="menu-item"
              :key="sidebarStepMenu[1].title"
              :menu="sidebarStepMenu[1]"
              :serial="2"
              :totalMenu="1"
              :menuIndex="1"
              :data-title="sidebarStepMenu[1].title"
            />
            <draggable
              :list="sidebarStepDragMenu"
              class="flex flex-col"
              group="menu-item"
              ghost-class="ghost"
              @end="changeEndSidebarStepDragMenu"
              :move="checkMoveSidebarStepDragMenu"
            >
              <template #item="{ element, index }">
                <Menu
                  class="menu-item"
                  :key="element.title"
                  :menu="element"
                  :serial="index + 3"
                  :totalMenu="sidebarStepDragMenu.length"
                  :menuIndex="index"
                  :data-title="element.title"
                />
              </template>
            </draggable>
            <Menu
              class="menu-item"
              :key="sidebarStepMenu[2].title"
              :menu="sidebarStepMenu[2]"
              :serial="8"
              :totalMenu="1"
              :menuIndex="1"
              :data-title="sidebarStepMenu[2].title"
            />
            <!-- <Menu
              class="menu-item"
              :key="$customizer.sidebarOverview.title"
              :menu="$customizer.sidebarOverview"
              :serial="sidebarMenu.length + 1"
              :totalMenu="sidebarMenu.length"
              :menuIndex="index"
              :data-title="$customizer.sidebarOverview.title"
              :draggable="false"
            /> -->

            <!-- </transition> -->
          </template>

          <template #settings>
            <MenuSettings />
          </template>
          <template #design>
            <MenuDesign />
          </template>
        </Tabs>
      </Sidebar>
    </div>

    <main
      class="py-[32px] bg-[#F9FAFB] h-screen overflow-y-scroll prebook-customizer"
      :style="{
        paddingLeft: isLg || isXl ? $customizer.sidebarWidth : '',
      }"
    >
      <router-view v-slot="{ Component }">
        <component :is="Component"></component>
      </router-view>
    </main>
  </div>
</template>
<style scoped></style>
